(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tapanda-delivery-promotion-banner"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('tp-delivery-promo-dialog');
  const opener = document.querySelector('[data-tp-delivery-open]');
  let trigger = null;
  let previousOverflow = null;
  let interval = null;
  let cutoffReached = false;
  const visible = node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';
  const restoreDialog = expired => {
    const style = document.documentElement.style;
    if (previousOverflow && style.getPropertyValue('overflow') === 'hidden') {
      if (previousOverflow.value) style.setProperty('overflow', previousOverflow.value, previousOverflow.priority);
      else style.removeProperty('overflow');
    }
    previousOverflow = null;
    if (trigger && trigger.isConnected) {
      if (!expired && visible(trigger)) trigger.focus({ preventScroll: true });
      else document.querySelector('main[tabindex], #MainContent')?.focus({ preventScroll: true });
    }
    trigger = null;
  };
  const expire = node => {
    if (node.hasAttribute('data-tp-delivery-inline')) {
      node.querySelector('[data-tp-delivery-active]').hidden = true;
      node.querySelector('[data-tp-delivery-expired]').hidden = false;
      node.classList.add('tp-delivery-promo-inline--expired');
    } else {
      if (node === dialog && dialog.open) {
        dialog.close();
        restoreDialog(true);
      }
      node.hidden = true;
    }
  };
  const refresh = () => {
    const now = Date.now();
    let active = false;
    document.querySelectorAll('[data-tp-delivery-deadline]').forEach(node => {
      const deadline = Date.parse(node.dataset.tpDeliveryDeadline);
      if (!Number.isFinite(deadline) || now >= deadline) cutoffReached = true;
      if (cutoffReached) {
        expire(node);
        return;
      }
      active = true;
      const seconds = Math.ceil((deadline - now) / 1000);
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor(seconds % 86400 / 3600);
      const minutes = Math.floor(seconds % 3600 / 60);
      const clock = [hours, minutes, seconds % 60].map(value => String(value).padStart(2, '0')).join(':');
      node.querySelectorAll('[data-tp-delivery-timer]').forEach(timer => {
        const text = `${days ? `${days}${timer.dataset.tpDeliveryDay} ` : ''}${clock}`;
        if (timer.textContent !== text) timer.textContent = text;
        timer.parentElement.hidden = false;
      });
    });
    if (active && interval === null) interval = window.setInterval(refresh, 1000);
    if (!active && interval !== null) {
      window.clearInterval(interval);
      interval = null;
    }
  };
  refresh();
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', refresh);
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-tp-delivery-deadline]') || node.querySelector('[data-tp-delivery-deadline]'))))) refresh();
  }).observe(document.body, { childList: true, subtree: true });
  if (!dialog || !opener || cutoffReached || typeof dialog.showModal !== 'function') return;
  const fallback = document.querySelector('[data-tp-delivery-fallback]');
  const hasOtherModal = () => Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"], cart-drawer.active, .drawer.active')).some(node => node !== dialog && visible(node));
  opener.hidden = false;
  if (fallback) fallback.hidden = true;
  opener.addEventListener('click', event => {
    refresh();
    if (event.defaultPrevented || cutoffReached || dialog.open || hasOtherModal()) return;
    trigger = opener;
    dialog.showModal();
    const style = document.documentElement.style;
    previousOverflow = { value: style.getPropertyValue('overflow'), priority: style.getPropertyPriority('overflow') };
    style.setProperty('overflow', 'hidden');
  });
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-tp-delivery-close]')) dialog.close();
    else if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    }
  });
  dialog.addEventListener('keydown', event => {
    if (event.key === 'Escape') event.stopPropagation();
    if (event.key !== 'Tab') return;
    const stops = dialog.querySelectorAll('button:not([disabled]), a[href]');
    const first = stops[0];
    const last = stops[stops.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  dialog.addEventListener('close', () => restoreDialog(cutoffReached));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tapanda-discount-tab"] && !Shopify.designMode) return;
  try {
    (function () {
    var tab = document.querySelector('[data-tapanda-discount-tab]');
    if (!tab || tab.getAttribute('data-tapanda-discount-tab-ready') === 'true') return;
    tab.setAttribute('data-tapanda-discount-tab-ready', 'true');

    /* ── Telefon: zakładka wysuwa się po chwili i po chwili chowa ──
       Na komputerze wisi cały czas (CSS), tu byłaby natrętna na wąskim ekranie.
       POKAZ_PO   — ile czekamy, zanim wyjedzie (użytkownik zdąży się rozejrzeć)
       WIDOCZNA   — jak długo zostaje na ekranie
       PRZERWA    — po zamknięciu/pokazaniu nie wraca przez ten czas w tej sesji */
    var POKAZ_PO = 12000;
    var WIDOCZNA = 9000;
    var KLUCZ = 'tp_tab_peeked';
    var waskiEkran = window.matchMedia('(max-width: 989px)');

    function juzPokazana() {
      try { return sessionStorage.getItem(KLUCZ) === '1'; } catch (e) { return false; }
    }
    function zapamietaj() {
      try { sessionStorage.setItem(KLUCZ, '1'); } catch (e) {}
    }

    if (waskiEkran.matches && !juzPokazana()) {
      window.setTimeout(function () {
        if (document.hidden) return;
        /* nie wchodzimy w drogę otwartemu oknu newslettera */
        if (document.body.classList.contains('tp-np-drawer-open')) return;
        var popup = document.getElementById('tp-newsletter-popup');
        if (popup && !popup.hidden) return;

        tab.classList.add('is-peeking');
        zapamietaj();

        window.setTimeout(function () {
          if (!document.body.classList.contains('tp-np-drawer-open')) {
            tab.classList.remove('is-peeking');
          }
        }, WIDOCZNA);
      }, POKAZ_PO);
    }
    tab.addEventListener('click', function () {
      /* Klik w wysuniętą zakładkę kończy jej pokaz — bez tego klasa is-peeking
         zostawała na stałe i zakładka wisiała do końca sesji. */
      tab.classList.remove('is-peeking');
      document.dispatchEvent(new CustomEvent('tapanda:newsletter:open', {
        detail: { trigger: tab }
      }));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
